var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2124_4183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0755 0L18.4157 0.0609951C26.8255 0.737086 33.4937 7.5803 33.9985 16.0263L34 17.8914C33.5517 26.5652 26.6286 33.515 17.9564 34.0007H16.0671C7.55956 33.5201 0.70547 26.8129 0.05438 18.3066L0 18.0759L0.0279249 15.9954C0.551884 7.3782 7.44345 0.515152 16.0605 0.0257208L18.0755 0ZM24.6702 28.9337C30.818 24.9845 32.9433 17.0191 29.6305 10.5514C26.3243 4.09549 18.6509 1.16038 11.8739 3.80374C4.01457 6.86893 0.582013 16.0241 4.3967 23.4758C8.18052 30.8672 17.5699 33.4944 24.6694 28.9337H24.6702Z",
    fill: "#2024BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4303 22.5124L16.2397 18.1957C15.812 17.9392 15.5967 17.4248 15.5967 16.9435L15.6011 8.4431C15.6011 7.65898 16.2794 7.10708 16.9804 7.09092C17.6815 7.07475 18.4222 7.63693 18.423 8.4431L18.4281 16.2064L24.8508 20.063C25.5299 20.4709 25.7275 21.3167 25.3498 21.9825C25 22.5998 24.1476 22.943 23.4296 22.5117L23.4303 22.5124Z",
    fill: "#2024BF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2124_4183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.034ea643930be4e491ed09096737998a.svg";
export { ForwardRef as ReactComponent };